const state = {
  // 轻量化模型查看页面
  fileModelView: {},

}
const getters = {
  fileModelView: (state) => { return state.fileModelView },
}
const mutations = {
  setFileModelView(state, data) {
    state.fileModelView = data || {}
  },
}
const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
